import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f528fa8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "应用信息", -1));
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "渠道", -1));
const _hoisted_8 = {
  class: "btn-content"
};
import { onMounted } from '@vue/runtime-core';
import { getNode } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'PaidFilterBlock',
  emits: ['filterSubmit', 'setProductName'],
  setup(__props, {
    expose,
    emit
  }) {
    const dbtId = ref(null); // 产品名
    const channel = ref(null); // 渠道
    const channelList = ref([{
      label: '全部',
      value: null
    }, {
      label: '华为',
      value: 'huawei'
    }]); // 渠道列表
    const filterSubmit = () => {
      let params = {
        chnl: channel.value,
        fuzzy: dbtId.value
      };
      emit('filterSubmit', params);
    }; // 搜索
    const init = () => {
      dbtId.value = null;
      channel.value = null;
      filterSubmit();
    }; // 初始化
    onMounted(() => {
      init();
    });
    expose({
      channel,
      dbtId
    });
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_input_search, {
        "allow-clear": "",
        placeholder: "产品名称/DBTID",
        value: dbtId.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => dbtId.value = $event),
        valueModifiers: {
          trim: true
        },
        onSearch: filterSubmit
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_select, {
        onChange: filterSubmit,
        value: channel.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => channel.value = $event),
        placeholder: "请选择",
        options: channelList.value,
        "get-popup-container": _unref(getNode)
      }, null, 8, ["value", "options", "get-popup-container"])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});